import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Minu ametnik", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_VoMinuAmetnik = _resolveComponent("VoMinuAmetnik")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.ametnikuInfo?.ametnik || _ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "pa-2"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_progress_circular, { indeterminate: "" })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_VoMinuAmetnik, { ametnikuInfo: _ctx.ametnikuInfo }, null, 8, ["ametnikuInfo"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}